import { combineReducers } from 'redux';
import applicationStore from './application.reducer';

export default combineReducers({
  applicationStore
});
